<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Community Skills'" [level]="5"></fui-heading>
  <button class="btn btn-secondary" (click)="showAddSkill()">
    <fa-icon icon="plus"></fa-icon>
    Add
  </button>
</div>
<div class="row">
  <div class="col-md-12">
    @for (skill of skills; track skill) {
      <div class="list-item hover">
        <div class="list-item-container">
          <div class="main-data">
            <span class="title">{{ skill.title }}</span>
            <span class="sub-data">
              {{ skill.type }}
              <br />
            </span>
          </div>
          <div class="buttons">
            <fa-icon icon="times" placement="top" ngbTooltip="Remove" class="action circle-icon-btn" (click)="deleteSkill(skill)"></fa-icon>
          </div>
        </div>
      </div>
    }
  </div>
</div>
